import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderItemProductFragment = { id: string, status?: string | null, productSku: string, productName?: string | null, returnStatus?: string | null, productType?: string | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, productSalePrice: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } };

export type OrderItemFragment = { id: string, number: string, orderDate: string, shippingMethod?: string | null, status: string, statusCode: string, shipments?: Array<{ tracking?: Array<{ number?: string | null } | null> | null } | null> | null, total?: { subtotal: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, subtotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null> | null, taxes?: Array<{ title: string, rate: number, amount: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null> | null, totalShipping: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, shippingHandling?: { amountExcludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null, amountIncludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null } | null, grandTotal: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null, items?: Array<OrderItemProductFragment | {} | null> | null };

export type StoreConfigDataFragment = { storeCode?: string | null, taxSalesDisplayPrice?: string | null, taxSalesDisplaySubtotal?: string | null };

export type OrderHistoryDetailQueryVariables = Types.Exact<{
  orderNumber?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type OrderHistoryDetailQuery = { magento2?: { storeConfig?: StoreConfigDataFragment | null, customer?: { email?: string | null, nativeId?: string | null, globalOrders?: { items: Array<{ id: string, number: string, orderDate: string, shippingMethod?: string | null, status: string, statusCode: string, shipments?: Array<{ tracking?: Array<{ number?: string | null } | null> | null } | null> | null, total?: { subtotal: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, subtotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, discounts?: Array<{ label: string, amount: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null> | null, taxes?: Array<{ title: string, rate: number, amount: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null> | null, totalShipping: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, shippingHandling?: { amountExcludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null, amountIncludingTax?: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } | null } | null, grandTotal: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null, items?: Array<{ id: string, status?: string | null, productSku: string, productName?: string | null, returnStatus?: string | null, productType?: string | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, productSalePrice: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | { id: string, status?: string | null, productSku: string, productName?: string | null, returnStatus?: string | null, productType?: string | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, productSalePrice: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | { id: string, status?: string | null, productSku: string, productName?: string | null, returnStatus?: string | null, productType?: string | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, productSalePrice: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | { id: string, status?: string | null, productSku: string, productName?: string | null, returnStatus?: string | null, productType?: string | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, productSalePrice: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null }, productSalePriceIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotal: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null }, rowTotalIncludingTax: { currency?: Types.Magento2_CurrencyEnum | null, value?: number | null } } | null> | null } | null> } | null } | null } | null };

export type AddressDetailsFragment = { prefix?: string | null, firstname: string, middlename?: string | null, lastname: string, suffix?: string | null, street: Array<string | null>, countryCode?: Types.Magento2_CountryCodeEnum | null, region?: string | null, postcode?: string | null, city: string, telephone?: string | null, company?: string | null };

export type PaymentDataFragment = { id: string, shippingMethod?: string | null, carrier?: string | null, billingAddress?: AddressDetailsFragment | null, shippingAddress?: AddressDetailsFragment | null, paymentMethods?: Array<{ name: string } | null> | null };

export type OrderHistoryDetailPaymentQueryVariables = Types.Exact<{
  orderNumber?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type OrderHistoryDetailPaymentQuery = { magento2?: { customer?: { nativeId?: string | null, globalOrders?: { items: Array<PaymentDataFragment | null> } | null } | null } | null };

export const OrderItemProductFragmentDoc = gql`
    fragment OrderItemProduct on Magento2_OrderItem {
  id
  status
  productSku
  productName
  returnStatus
  productSalePrice {
    value
    currency
  }
  productSalePriceIncludingTax {
    currency
    value
  }
  rowTotal {
    currency
    value
  }
  rowTotalIncludingTax {
    currency
    value
  }
  productType
  quantityOrdered
  quantityRefunded
  quantityReturned
  eligibleForReturn
  quantityCanceled
  quantityInvoiced
}
    `;
export const OrderItemFragmentDoc = gql`
    fragment OrderItem on Magento2_GlobalCustomerOrder {
  id
  number
  orderDate
  shippingMethod
  shipments {
    tracking {
      number
    }
  }
  total {
    subtotal {
      value
      currency
    }
    subtotalIncludingTax {
      currency
      value
    }
    discounts {
      label
      amount {
        value
        currency
      }
    }
    taxes {
      title
      rate
      amount {
        value
        currency
      }
    }
    totalShipping {
      value
      currency
    }
    shippingHandling {
      amountExcludingTax {
        value
        currency
      }
      amountIncludingTax {
        value
        currency
      }
    }
    grandTotal {
      value
      currency
    }
  }
  status
  statusCode
  items {
    ...OrderItemProduct
  }
}
    ${OrderItemProductFragmentDoc}`;
export const StoreConfigDataFragmentDoc = gql`
    fragment StoreConfigData on Magento2_StoreConfig {
  storeCode
  taxSalesDisplayPrice
  taxSalesDisplaySubtotal
}
    `;
export const AddressDetailsFragmentDoc = gql`
    fragment AddressDetails on Magento2_OrderAddress {
  prefix
  firstname
  middlename
  lastname
  suffix
  street
  countryCode
  region
  postcode
  city
  telephone
  company
}
    `;
export const PaymentDataFragmentDoc = gql`
    fragment PaymentData on Magento2_GlobalCustomerOrder {
  id
  billingAddress {
    ...AddressDetails
  }
  shippingAddress {
    ...AddressDetails
  }
  shippingMethod
  carrier
  paymentMethods {
    name
  }
}
    ${AddressDetailsFragmentDoc}`;
export const OrderHistoryDetailDocument = gql`
    query OrderHistoryDetail($orderNumber: String) {
  magento2 {
    storeConfig {
      ...StoreConfigData
    }
    customer {
      email
      nativeId
      globalOrders(filter: {number: {eq: $orderNumber}}) {
        items {
          id
          number
          orderDate
          shippingMethod
          shipments {
            tracking {
              number
            }
          }
          total {
            subtotal {
              value
              currency
            }
            subtotalIncludingTax {
              currency
              value
            }
            discounts {
              label
              amount {
                value
                currency
              }
            }
            taxes {
              title
              rate
              amount {
                value
                currency
              }
            }
            totalShipping {
              value
              currency
            }
            shippingHandling {
              amountExcludingTax {
                value
                currency
              }
              amountIncludingTax {
                value
                currency
              }
            }
            grandTotal {
              value
              currency
            }
          }
          status
          statusCode
          items {
            id
            status
            productSku
            productName
            returnStatus
            productSalePrice {
              value
              currency
            }
            productSalePriceIncludingTax {
              currency
              value
            }
            rowTotal {
              currency
              value
            }
            rowTotalIncludingTax {
              currency
              value
            }
            productType
            quantityOrdered
            quantityRefunded
            quantityReturned
            eligibleForReturn
            quantityCanceled
            quantityInvoiced
          }
        }
      }
    }
  }
}
    ${StoreConfigDataFragmentDoc}`;

/**
 * __useOrderHistoryDetailQuery__
 *
 * To run a query within a React component, call `useOrderHistoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoryDetailQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useOrderHistoryDetailQuery(baseOptions?: Apollo.QueryHookOptions<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>(OrderHistoryDetailDocument, options);
      }
export function useOrderHistoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>(OrderHistoryDetailDocument, options);
        }
export type OrderHistoryDetailQueryHookResult = ReturnType<typeof useOrderHistoryDetailQuery>;
export type OrderHistoryDetailLazyQueryHookResult = ReturnType<typeof useOrderHistoryDetailLazyQuery>;
export type OrderHistoryDetailQueryResult = Apollo.QueryResult<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>;
export const OrderHistoryDetailPaymentDocument = gql`
    query OrderHistoryDetailPayment($orderNumber: String) {
  magento2 {
    customer {
      nativeId
      globalOrders(filter: {number: {eq: $orderNumber}}) {
        items {
          ...PaymentData
        }
      }
    }
  }
}
    ${PaymentDataFragmentDoc}`;

/**
 * __useOrderHistoryDetailPaymentQuery__
 *
 * To run a query within a React component, call `useOrderHistoryDetailPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoryDetailPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoryDetailPaymentQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useOrderHistoryDetailPaymentQuery(baseOptions?: Apollo.QueryHookOptions<OrderHistoryDetailPaymentQuery, OrderHistoryDetailPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderHistoryDetailPaymentQuery, OrderHistoryDetailPaymentQueryVariables>(OrderHistoryDetailPaymentDocument, options);
      }
export function useOrderHistoryDetailPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderHistoryDetailPaymentQuery, OrderHistoryDetailPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderHistoryDetailPaymentQuery, OrderHistoryDetailPaymentQueryVariables>(OrderHistoryDetailPaymentDocument, options);
        }
export type OrderHistoryDetailPaymentQueryHookResult = ReturnType<typeof useOrderHistoryDetailPaymentQuery>;
export type OrderHistoryDetailPaymentLazyQueryHookResult = ReturnType<typeof useOrderHistoryDetailPaymentLazyQuery>;
export type OrderHistoryDetailPaymentQueryResult = Apollo.QueryResult<OrderHistoryDetailPaymentQuery, OrderHistoryDetailPaymentQueryVariables>;